
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminDashboardOrganizationConfiguration"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"originalId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"slug"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isCorporation"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"logoThumbnail"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"configuration"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canUploadCourses"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"canUseInduction"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"canUseIntegrations"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hasGamificationAvailable"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hasLiveSessionAvailable"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hasStudioAvailable"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hasRequestedDemoElevate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hasSeenWellcomeToElevate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hasSkillXpEvolutionAvailable"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"darkModeLogo"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isotype"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"darkModeIsotype"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"emailLogo"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"emailPrimaryColor"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"demoConfig"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasProductDemoTest"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":607}};
    doc.loc.source = {"body":"query AdminDashboardOrganizationConfiguration($slug: String) {\n  organization(slug: $slug) {\n    originalId\n    name\n    slug\n    isCorporation\n    logoThumbnail\n    configuration {\n      canUploadCourses\n      canUseInduction\n      canUseIntegrations\n      hasGamificationAvailable\n      hasLiveSessionAvailable\n      hasStudioAvailable\n      hasRequestedDemoElevate\n      hasSeenWellcomeToElevate\n      hasSkillXpEvolutionAvailable\n      darkModeLogo\n      isotype\n      darkModeIsotype\n      emailLogo\n      emailPrimaryColor\n    }\n    demoConfig {\n      hasProductDemoTest\n      description\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["AdminDashboardOrganizationConfiguration"] = oneQuery(doc, "AdminDashboardOrganizationConfiguration");
        
